import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Box, Button, Card, CardContent, Typography, Fade, } from "@mui/material";
import dayjs from "dayjs";
const AnimatedMessage = ({ userName, user, isConfirmed, }) => {
    const getUserName = () => {
        const possibleNames = [
            userName,
            user === null || user === void 0 ? void 0 : user.name,
            user === null || user === void 0 ? void 0 : user.firstName,
            user === null || user === void 0 ? void 0 : user.fullName,
            user === null || user === void 0 ? void 0 : user.yourName,
            user === null || user === void 0 ? void 0 : user.displayName,
            user === null || user === void 0 ? void 0 : user.first_name,
            user === null || user === void 0 ? void 0 : user.full_name,
            user === null || user === void 0 ? void 0 : user.your_name,
            user === null || user === void 0 ? void 0 : user.display_name,
        ];
        const validName = possibleNames.find((name) => name && name.trim() !== "");
        return validName || "usuário";
    };
    const fullText = isConfirmed
        ? `Olá, ${getUserName()}, você já possui um agendamento confirmado para doação de sangue!`
        : `Olá, ${getUserName()}, você ainda não possui doações registradas, estamos com os estoques baixos, achei um horário e um local próximo com base no seu perfil, podemos agendar?`;
    return (_jsx(Fade, Object.assign({ in: true, timeout: 1000 }, { children: _jsxs(Box, Object.assign({ sx: {
                display: "flex",
                alignItems: "flex-start",
                gap: "10px",
                mb: 2,
                width: 905,
                height: 168,
                overflow: "hidden",
            } }, { children: [_jsx(Box, Object.assign({ sx: {
                        width: 174,
                        height: 168,
                        gap: "10px",
                        opacity: 1,
                        transition: "opacity 1s ease-in-out",
                        flexShrink: 0,
                    } }, { children: _jsx("img", { src: `${process.env.PUBLIC_URL}/images/robo.gif`, alt: "rob\u00F4", style: {
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            imageRendering: "auto",
                        } }) })), _jsx(Box, Object.assign({ sx: {
                        width: 731,
                        height: 116,
                        gap: "10px",
                        borderTopLeftRadius: "20px",
                        borderTopRightRadius: "20px",
                        borderBottomRightRadius: "20px",
                        padding: "16px",
                        borderWidth: "2px",
                        background: "var(--hemoes-lia-card-bg)",
                        border: isConfirmed
                            ? "2px solid var(--hemoes-lia-card-border-confirmed)"
                            : "2px solid var(--hemoes-lia-card-border-default)",
                        opacity: 1,
                        transition: "opacity 1s ease-in-out",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "flex-start",
                    } }, { children: _jsxs(Box, Object.assign({ sx: { display: "flex", flexDirection: "column", gap: 0.5 } }, { children: [isConfirmed && (_jsx(Typography, Object.assign({ sx: {
                                    fontFamily: "Montserrat, sans-serif",
                                    fontWeight: 600,
                                    fontSize: "calc(14px + var(--accessibility-font-delta, 0px))",
                                    lineHeight: "18px",
                                    letterSpacing: "0.5px",
                                    color: "var(--hemoes-lia-card-label-text)",
                                    textAlign: "left",
                                    mb: 1,
                                } }, { children: "\u2713 AGENDAMENTO CONFIRMADO" }))), _jsx(Typography, Object.assign({ sx: {
                                    fontFamily: "Montserrat, sans-serif",
                                    fontWeight: 500,
                                    fontSize: "calc(18px + var(--accessibility-font-delta, 0px))",
                                    lineHeight: "28px",
                                    letterSpacing: "0px",
                                    color: "var(--hemoes-lia-card-text)",
                                    textAlign: "left",
                                    minHeight: "28px",
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                } }, { children: fullText }))] })) }))] })) })));
};
const ScheduleCardCompact = ({ municipio, servico, unidade, data, hora, onConfirm, userName, user, isConfirmed, onCancel, onViewDetails, isLoading, }) => {
    const handleConfirmar = () => {
        onConfirm();
    };
    const formatarData = (dataString) => {
        if (!dataString) {
            return "";
        }
        const dataObj = dayjs(dataString, ["DD/MM/YYYY", "YYYY-MM-DD"]);
        if (!dataObj.isValid()) {
            return "";
        }
        return dataObj.format("DD/MM/YYYY");
    };
    const formattedDate = formatarData(data);
    const dataValida = Boolean(formattedDate);
    return (_jsxs(Box, { children: [_jsx(AnimatedMessage, { userName: userName, user: user, isConfirmed: isConfirmed }), _jsx(Card, Object.assign({ sx: {
                    width: 905,
                    height: isConfirmed ? 200 : 136,
                    gap: "24px",
                    borderTopLeftRadius: "20px",
                    borderTopRightRadius: "20px",
                    borderBottomRightRadius: "20px",
                    padding: "16px",
                    background: "var(--hemoes-lia-card-bg)",
                    boxShadow: "0px -6px 15px 0px #00000012",
                    border: isConfirmed
                        ? "2px solid var(--hemoes-lia-card-border-confirmed)"
                        : "none",
                } }, { children: _jsxs(CardContent, Object.assign({ sx: { p: 0, "&:last-child": { pb: 0 } } }, { children: [isConfirmed && (_jsx(Box, Object.assign({ sx: {
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                mb: 2,
                                p: 1,
                                borderRadius: "8px",
                                background: "var(--hemoes-lia-card-label-bg)",
                                border: "1px solid var(--hemoes-lia-card-label-border)",
                            } }, { children: _jsx(Typography, Object.assign({ sx: {
                                    fontFamily: "Montserrat, sans-serif",
                                    fontWeight: 600,
                                    fontSize: "calc(12px + var(--accessibility-font-delta, 0px))",
                                    lineHeight: "16px",
                                    letterSpacing: "0.5px",
                                    color: "var(--hemoes-lia-card-label-text)",
                                } }, { children: "\u2713 Este \u00E9 o seu agendamento atual" })) }))), _jsxs(Box, Object.assign({ sx: {
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mb: 3,
                            } }, { children: [_jsxs(Box, { children: [_jsx(Typography, Object.assign({ variant: "subtitle2", sx: {
                                                fontFamily: "Montserrat, sans-serif",
                                                fontSize: "calc(14px + var(--accessibility-font-delta, 0px))",
                                                lineHeight: "18px",
                                                letterSpacing: "0.5px",
                                                color: "var(--hemoes-lia-card-meta-text)",
                                            } }, { children: "Servi\u00E7o" })), _jsx(Typography, Object.assign({ sx: {
                                                fontFamily: "Montserrat, sans-serif",
                                                fontWeight: 600,
                                                fontSize: "calc(16px + var(--accessibility-font-delta, 0px))",
                                                lineHeight: "24px",
                                                letterSpacing: "0px",
                                                verticalAlign: "middle",
                                                color: "var(--hemoes-lia-card-text)",
                                            } }, { children: servico }))] }), _jsxs(Box, { children: [_jsx(Typography, Object.assign({ variant: "subtitle2", sx: {
                                                fontFamily: "Montserrat, sans-serif",
                                                fontWeight: 500,
                                                fontSize: "calc(14px + var(--accessibility-font-delta, 0px))",
                                                lineHeight: "18px",
                                                letterSpacing: "0.5px",
                                                color: "var(--hemoes-lia-card-meta-text)",
                                            } }, { children: "Data" })), _jsx(Typography, Object.assign({ sx: {
                                                fontFamily: "Montserrat, sans-serif",
                                                fontWeight: 600,
                                                fontSize: "calc(16px + var(--accessibility-font-delta, 0px))",
                                                lineHeight: "24px",
                                                letterSpacing: "0px",
                                                verticalAlign: "middle",
                                                color: dataValida
                                                    ? "var(--hemoes-lia-card-text)"
                                                    : "var(--hemoes-lia-card-error-text)",
                                            } }, { children: dataValida
                                                ? `${formattedDate} - ${hora}h`
                                                : "Data inválida ou não disponível" }))] }), _jsxs(Box, { children: [_jsx(Typography, Object.assign({ variant: "subtitle2", sx: {
                                                fontFamily: "Montserrat, sans-serif",
                                                fontSize: "calc(14px + var(--accessibility-font-delta, 0px))",
                                                lineHeight: "18px",
                                                letterSpacing: "0.5px",
                                                color: "var(--hemoes-lia-card-meta-text)",
                                            } }, { children: "Unidade de Atendimento" })), _jsx(Typography, Object.assign({ sx: {
                                                fontFamily: "Montserrat, sans-serif",
                                                fontWeight: 600,
                                                fontSize: "calc(16px + var(--accessibility-font-delta, 0px))",
                                                lineHeight: "24px",
                                                letterSpacing: "0px",
                                                verticalAlign: "middle",
                                                color: "var(--hemoes-lia-card-text)",
                                            } }, { children: unidade }))] }), _jsxs(Box, { children: [_jsx(Typography, Object.assign({ variant: "subtitle2", sx: {
                                                fontFamily: "Montserrat, sans-serif",
                                                fontWeight: 500,
                                                fontSize: "calc(14px + var(--accessibility-font-delta, 0px))",
                                                lineHeight: "18px",
                                                letterSpacing: "0.5px",
                                                color: "var(--hemoes-lia-card-meta-text)",
                                            } }, { children: "Munic\u00EDpio" })), _jsx(Typography, Object.assign({ sx: {
                                                fontFamily: "Montserrat, sans-serif",
                                                fontWeight: 600,
                                                fontSize: "calc(16px + var(--accessibility-font-delta, 0px))",
                                                lineHeight: "24px",
                                                letterSpacing: "0px",
                                                verticalAlign: "middle",
                                                color: "var(--hemoes-lia-card-text)",
                                            } }, { children: municipio }))] })] })), _jsx(Box, Object.assign({ display: "flex", flexDirection: "row", gap: 2 }, { children: !isConfirmed ? (_jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ variant: "contained", onClick: handleConfirmar, disabled: isLoading, "data-testid": "confirm-appointment-button", sx: {
                                            width: 420.5,
                                            height: 42,
                                            gap: "8px",
                                            padding: "16px 24px",
                                            borderRadius: "35px",
                                            background: "var(--hemoes-lia-card-button-primary-bg)",
                                            border: "2px solid var(--hemoes-lia-card-button-primary-border)",
                                            boxShadow: "0px 5px 15px 0px #00000040",
                                            fontFamily: "Montserrat, sans-serif",
                                            fontWeight: 600,
                                            fontSize: "calc(14px + var(--accessibility-font-delta, 0px))",
                                            lineHeight: "20px",
                                            letterSpacing: "0.7px",
                                            textAlign: "center",
                                            verticalAlign: "middle",
                                            color: "var(--hemoes-lia-card-button-primary-text)",
                                            textTransform: "none",
                                        } }, { children: isLoading ? "Processando..." : "Confirmar Agendamento" })), _jsx(Button, Object.assign({ variant: "outlined", href: "/app/agendamento/one/doacao-de-sangue", "data-testid": "find-more-schedules-button", sx: {
                                            width: 420.5,
                                            height: 42,
                                            gap: "8px",
                                            padding: "16px 24px",
                                            borderRadius: "35px",
                                            border: "2px solid var(--hemoes-lia-card-button-secondary-border)",
                                            boxShadow: "0px 5px 15px 0px #00000040",
                                            fontFamily: "Montserrat, sans-serif",
                                            fontWeight: 600,
                                            fontSize: "calc(14px + var(--accessibility-font-delta, 0px))",
                                            lineHeight: "20px",
                                            letterSpacing: "0.7px",
                                            textAlign: "center",
                                            verticalAlign: "middle",
                                            color: "var(--hemoes-lia-card-button-secondary-text)",
                                            textTransform: "none",
                                        } }, { children: isConfirmed
                                            ? "Ver mais horários"
                                            : "Encontrar mais horários" }))] })) : (_jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ variant: "contained", onClick: onViewDetails, "data-testid": "view-appointment-details-button", sx: {
                                            width: 420.5,
                                            height: 42,
                                            gap: "8px",
                                            padding: "16px 24px",
                                            borderRadius: "35px",
                                            background: "var(--hemoes-lia-card-button-primary-bg)",
                                            border: "2px solid var(--hemoes-lia-card-button-primary-border)",
                                            boxShadow: "0px 5px 15px 0px #00000040",
                                            fontFamily: "Montserrat, sans-serif",
                                            fontWeight: 600,
                                            fontSize: "calc(14px + var(--accessibility-font-delta, 0px))",
                                            lineHeight: "20px",
                                            letterSpacing: "0.7px",
                                            textAlign: "center",
                                            verticalAlign: "middle",
                                            color: "var(--hemoes-lia-card-button-primary-text)",
                                            textTransform: "none",
                                        } }, { children: "Ver detalhes do agendamento" })), _jsx(Button, Object.assign({ variant: "outlined", onClick: onCancel, "data-testid": "cancel-appointment-button", sx: {
                                            width: 420.5,
                                            height: 42,
                                            gap: "8px",
                                            padding: "16px 24px",
                                            borderRadius: "35px",
                                            border: "2px solid var(--hemoes-lia-card-button-cancel-border)",
                                            boxShadow: "0px 5px 15px 0px #00000040",
                                            fontFamily: "Montserrat, sans-serif",
                                            fontWeight: 600,
                                            fontSize: "calc(14px + var(--accessibility-font-delta, 0px))",
                                            lineHeight: "20px",
                                            letterSpacing: "0.7px",
                                            textAlign: "center",
                                            verticalAlign: "middle",
                                            color: "var(--hemoes-lia-card-button-cancel-text)",
                                            textTransform: "none",
                                        } }, { children: "Cancelar Agendamento" }))] })) }))] })) }))] }));
};
export default ScheduleCardCompact;
